import { combineReducers } from 'redux';
import { cart } from './Reducers/Cart.reducer';
import { quickSearch } from './Reducers/QuickSearch.reducer';
import { navigation } from './Reducers/Navigation.reducer';
import { hamburgerNavigation } from './Reducers/HamburgerNavigation.reducer';
import { facetedSearch } from './Reducers/FacetedSearch.reducer';
import { checkout } from './Reducers/Checkout.reducer';
import { myPage } from './Reducers/MyPage.reducer';
import { articles } from './Reducers/ProductConfigurator.reducer';
import { addons } from './Reducers/AddonProduct.reducer';

const staticReducers = {
    cart,
    quickSearch,
    navigation,
    hamburgerNavigation,
    facetedSearch,
    checkout,
    myPage,
    articles,
    addons
};

const app = combineReducers(staticReducers);

export const createReducer = (asyncReducers) => {
    return combineReducers({
        ...staticReducers,
        ...asyncReducers,
    });
};

export default app;
